import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types'

const selectUIState = (state: RootState) => state.ui

/**
 * Selector para obter todos os toasts
 */
export const selectToasts = createSelector(
  [selectUIState],
  (ui) => ui.toasts
)

/**
 * Selector para obter toasts por tipo
 */
export const selectToastsByType = (type: 'success' | 'error' | 'warning' | 'info') =>
  createSelector(
    [selectToasts],
    (toasts) => toasts.filter(toast => toast.type === type)
  )

